import _ from 'lodash';
import $ from 'jquery';
import { Consts, window } from '@wix/photography-client-lib';
var ZoomPinch = /** @class */ (function () {
    function ZoomPinch(config, callback) {
        var _this = this;
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.init(config);
        this.initDefaults();
        this.swipeCallback = _.isFunction(callback) ? callback : _.noop;
        this.opts = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function () {
                    // console.log('Browser has passive events');
                    _this.opts = {
                        passive: true,
                    };
                },
            });
            window.addEventListener('test', null, opts);
        }
        catch (e) { }
    }
    // --------------------| INIT |--------------------//
    ZoomPinch.prototype.init = function (config) {
        this.fullscreenItem = config.fullscreenItem;
        this.initElements();
        this.initEvents();
        this.setConfiguration(config);
    };
    ZoomPinch.prototype.initElements = function () {
        this.fullscreenParent = $('#fullscreen-view');
        this.wrap = $('.mobile-zoom-item-wrapper');
        this.image = $('.high-res-zoom-image');
        this.preloadImage = $('.preload-zoom-image');
        this.slides = $('.pro-fullscreen-slide');
        this.current = $('.mobile-zoom-item-wrapper');
        this.currentItem = $('.mobile-zoom-item-wrapper');
        this.nextItem = $('.next-slide .fullscreen-item');
        this.prevItem = $('.prev-slide .fullscreen-item');
        this.slider = $('#slider');
        this.currentItemContainer = $('.current-slide');
        this.nextItemContainer = $('.next-slide');
        this.prevItemContainer = $('.prev-slide');
        this.currentItemContent = $('.current-slide .fullscreen-content');
        this.nextItemContent = $('.next-slide .fullscreen-content');
        this.prevItemContent = $('.prev-slide .fullscreen-content');
        this.otherItemContainers = $('.swipe-far-away');
        this.isLastSlide = this.nextItem.length === 0;
        this.isFirstSlide = this.prevItem.length === 0;
        this.direction = 0;
    };
    ZoomPinch.prototype.initEvents = function () {
        if (this.fullscreenParent[0]) {
            this.fullscreenParent[0].removeEventListener('touchstart', this.onTouchStart, this.opts);
            this.fullscreenParent[0].addEventListener('touchstart', this.onTouchStart, this.opts);
            this.fullscreenParent[0].removeEventListener('touchmove', this.onTouchMove, this.opts);
            this.fullscreenParent[0].removeEventListener('touchend', this.onTouchEnd, this.opts);
            this.fullscreenParent[0].addEventListener('touchmove', this.onTouchMove, this.opts);
            this.fullscreenParent[0].addEventListener('touchend', this.onTouchEnd, this.opts);
        }
    };
    ZoomPinch.prototype.initDefaults = function () {
        this.scale = 1;
        this.pos = {
            x: 0,
            y: 0,
        };
        this.pinchStart = {
            dist: 0,
            x: 0,
            y: 0,
        };
        this.hiResShown = true;
        this.nonCurrentShown = true;
        this.enabled = true;
        this.beforeAnimation = true;
        this.willSwipeItem = false;
        this.isFinalMove = false;
    };
    ZoomPinch.prototype.disable = function () {
        this.enabled = false;
        window.document.removeEventListener('touchstart', this.preventDefault);
        window.document.removeEventListener('touchmove', this.preventDefault);
        setTimeout(this.enable.bind(this), 1000); // make sure we're not stuck on disabled mode
    };
    ZoomPinch.prototype.preventDefault = function (e) {
        try {
            if (e.touches.length > 1) {
                // prevent the browser's native pinch to zoom
                e.preventDefault();
            }
        }
        catch (err) {
            //
        }
        return true;
    };
    ZoomPinch.prototype.enable = function () {
        this.enabled = true;
        try {
            window.document.addEventListener('touchstart', this.preventDefault, {
                passive: false,
            });
            window.document.addEventListener('touchmove', this.preventDefault, {
                passive: false,
            });
        }
        catch (e) {
            //
        }
    };
    ZoomPinch.prototype.update = function () {
        this.initElements();
        this.beforeAnimation = true;
    };
    // --------------------| ACTIONS |--------------------//
    ZoomPinch.prototype.disableScroll = function () {
        if (this.scrollDisabled) {
            this.wrap && this.wrap.addClass('pro-fullscreen-unscrollable');
            this.scrollDisabled = false;
        }
    };
    ZoomPinch.prototype.enableScroll = function () {
        if (!this.scrollDisabled) {
            this.wrap && this.wrap.removeClass('pro-fullscreen-unscrollable');
            this.scrollDisabled = true;
        }
    };
    ZoomPinch.prototype.turnTransitionOff = function () {
        if (this.transitionOn) {
            this.wrap && this.wrap.addClass('pro-fullscreen-touching');
            this.transitionOn = false;
        }
    };
    ZoomPinch.prototype.turnTransitionOn = function () {
        if (!this.transitionOn) {
            this.wrap && this.wrap.removeClass('pro-fullscreen-touching');
            this.transitionOn = true;
        }
    };
    ZoomPinch.prototype.hideHiResImages = function () {
        if (this.hiResShown) {
            this.wrap && this.wrap.addClass('pro-fullscreen-moving');
            this.hiResShown = false;
        }
    };
    ZoomPinch.prototype.showHiResImages = function () {
        if (!this.hiResShown) {
            this.wrap && this.wrap.removeClass('pro-fullscreen-moving');
            this.hiResShown = true;
        }
    };
    ZoomPinch.prototype.hideNonCurrentImages = function () {
        if (this.nonCurrentShown) {
            this.wrap && this.wrap.addClass('pro-fullscreen-pinching');
            this.nonCurrentShown = false;
        }
    };
    ZoomPinch.prototype.showNonCurrentImages = function () {
        if (!this.nonCurrentShown) {
            this.wrap && this.wrap.removeClass('pro-fullscreen-pinching');
            this.nonCurrentShown = true;
        }
    };
    ZoomPinch.prototype.setConfiguration = function (config) {
        this.container = {
            width: config.container.width,
            height: config.container.height,
        };
        this.onTap = config.onTap || function () { };
        this.toggleZoom = config.toggleZoom || function () { };
        this.allowSwipe = !!config.allowSwipe;
        this.allowPinch = !!config.allowPinch;
        this.allowScroll = !!config.allowScroll;
        this.mobileSwipeAnimation = config.mobileSwipeAnimation;
        this.rtlFix = config.isRTL ? -1 : 1;
        if (!this.allowPinch) {
            this.resetScale();
        }
    };
    ZoomPinch.prototype.move = function () {
        if (this.scale === 1) {
            var percentOfScreen = Math.max(0, Math.min(1, 1 - Math.abs(this.pos.x / this.container.width)));
            var isDuringAnimation = percentOfScreen < 1 && percentOfScreen > 0;
            this.wrap.removeClass('pro-fullscreen-before-swipe');
            var _a = Consts.mobileSwipeAnimations, EXPAND = _a.EXPAND, FADE = _a.FADE, CAROUSEL = _a.CAROUSEL, CROSSFADE = _a.CROSSFADE;
            switch (this.mobileSwipeAnimation) {
                case EXPAND:
                    this.expandAnimation(percentOfScreen);
                    break;
                case FADE:
                    this.fadeAnimation(percentOfScreen, isDuringAnimation);
                    break;
                case CAROUSEL:
                    this.carouselAnimation(percentOfScreen, isDuringAnimation);
                    break;
                case CROSSFADE:
                    // not working yet
                    // this.crossfadeAnimation(percentOfScreen, isDuringAnimation);
                    break;
            }
        }
        else {
            var val = "translate3d(".concat(this.pos.x, "px ,").concat(this.pos.y, "px ,0)");
            var _b = this.fullscreenItem, width = _b.width, height = _b.height;
            this.wrap.css({
                transform: val,
                '-o-transform': val,
                '-ms-transform': val,
                '-webkit-transform': val,
            });
            this.image.css({
                width: "".concat(width * this.scale, "px"),
                height: "".concat(height * this.scale, "px"),
            });
            this.preloadImage.css({
                width: "".concat(width * this.scale, "px"),
                height: "".concat(height * this.scale, "px"),
            });
        }
    };
    ZoomPinch.prototype.expandAnimation = function (percentOfScreen) {
        var scale = Math.round(100 * Math.max(0, (percentOfScreen - 0.5) * 2 - 0.96)) / 100 +
            0.96;
        var val = "translate3d(".concat(this.pos.x, "px ,").concat(this.pos.y, "px ,0)");
        this.wrap.css({
            transform: val,
            '-o-transform': val,
            '-ms-transform': val,
            '-webkit-transform': val,
        });
        this.currentItemContainer.css({
            transform: "scale(".concat(scale, ")"),
            opacity: 1,
        });
        this.nextItemContainer.css({
            transform: "scale(".concat(scale, ")"),
            opacity: 1,
        });
        this.prevItemContainer.css({
            transform: "scale(".concat(scale, ")"),
            opacity: 1,
        });
    };
    ZoomPinch.prototype.fadeAnimation = function (percentOfScreen, isDuringAnimation) {
        var val = "translate3d(".concat(this.pos.x, "px ,").concat(this.pos.y, "px ,0)");
        if (this.isFinalMove) {
            this.wrap.css({
                transform: val,
                transition: 'transform 400ms ease-in',
                '-o-transform': val,
                '-ms-transform': val,
                '-webkit-transform': val,
            });
        }
        else {
            this.wrap.css({
                transform: val,
                '-o-transform': val,
                '-ms-transform': val,
                '-webkit-transform': val,
            });
        }
        if (this.beforeAnimation) {
            this.currentItemContainer.css({
                opacity: 1,
                transition: "none",
                transform: "scale(1) translateX(0px)",
            });
            this.nextItemContainer.css({
                opacity: 0,
                transition: "none",
                transform: "scale(1) translateX(0px)",
            });
            this.prevItemContainer.css({
                opacity: 0,
                transition: "none",
                transform: "scale(1) translateX(0px)",
            });
        }
        else if (isDuringAnimation) {
            var fastOpacity = Math.max(0, (percentOfScreen - 0.5) * 2);
            var oppositeFastOpacity = Math.max(0, (1 - percentOfScreen - 0.5) * 2);
            this.currentItemContainer.css({
                opacity: fastOpacity,
            });
            this.nextItemContainer.css({
                opacity: oppositeFastOpacity,
            });
            this.prevItemContainer.css({
                opacity: oppositeFastOpacity,
            });
        }
        else if (this.isFinalMove && this.willSwipeItem) {
            // percentOfScreen = 0
            this.currentItemContainer.css({
                transition: "opacity 400ms ease-in",
                opacity: 0,
            });
            this.nextItemContainer.css({
                transition: "opacity 400ms ease-in",
                opacity: 1,
            });
            this.prevItemContainer.css({
                transition: "opacity 400ms ease-in",
                opacity: 1,
            });
        }
        else if (this.isFinalMove && !this.willSwipeItem) {
            // percentOfScreen = 1
            this.currentItemContainer.css({
                transition: "opacity 400ms ease-in",
                opacity: 1,
            });
            this.nextItemContainer.css({
                transition: "opacity 400ms ease-in",
                opacity: 0,
            });
            this.prevItemContainer.css({
                transition: "opacity 400ms ease-in",
                opacity: 0,
            });
        }
    };
    ZoomPinch.prototype.carouselAnimation = function (percentOfScreen, isDuringAnimation) {
        var right2Left = this.pos.x / this.container.width <= 0;
        var val = "translateX(".concat(this.pos.x, "px)");
        if (this.isFinalMove) {
            this.wrap.css({
                transform: val,
                transition: 'transform 400ms ease-in',
                '-o-transform': val,
                '-ms-transform': val,
                '-webkit-transform': val,
            });
        }
        else {
            this.wrap.css({
                transform: val,
                transition: "none",
                '-o-transform': val,
                '-ms-transform': val,
                '-webkit-transform': val,
            });
        }
        if (this.beforeAnimation) {
            this.currentItemContainer.css({
                zIndex: 9999,
                transform: "scale(1)",
                transition: "none",
                opacity: 1,
            });
            this.currentItemContent.css({
                filter: "none",
            });
            this.nextItemContainer.css({
                zIndex: 0,
                transform: "scale(".concat(1 - percentOfScreen / 10, ")"),
                transition: "none",
                opacity: 1,
            });
            this.nextItemContent.css({
                filter: "none",
            });
            this.prevItemContainer.css({
                zIndex: 0,
                transform: "scale(".concat(1 - percentOfScreen / 10, ")"),
                transition: "none",
                opacity: 1,
            });
            this.prevItemContent.css({
                filter: "none",
            });
        }
        else if (isDuringAnimation) {
            this.currentItemContainer.css({
                transform: "scale(".concat(1 - (1 - percentOfScreen) / 10, ") translateX(").concat(right2Left
                    ? Math.max(0, (0.5 - percentOfScreen) * 50)
                    : Math.min(0, (0.5 - percentOfScreen) * -50), "px)"),
                zIndex: "".concat(percentOfScreen > 0.5 ? 9999 : 0),
            });
            this.currentItemContent.css({
                filter: "blur(".concat((1 - percentOfScreen) * 2, "px) brightness(").concat(0.75 + percentOfScreen * 0.25, ")"),
            });
            this.nextItemContainer.css({
                transform: "scale(".concat(1 - percentOfScreen / 10, ") translateX(").concat(Math.min(0, (0.5 - percentOfScreen) * 50), "px)"),
                zIndex: "".concat(percentOfScreen > 0.5 ? 0 : 9999),
            });
            this.nextItemContent.css({
                filter: "blur(".concat(percentOfScreen * 2, "px) brightness(").concat(1 - percentOfScreen * 0.25, ")"),
            });
            this.prevItemContainer.css({
                transform: "scale(".concat(1 - percentOfScreen / 10, ") translateX(").concat(Math.max(0, (0.5 - percentOfScreen) * -50), "px)"),
                zIndex: "".concat(percentOfScreen > 0.5 ? 0 : 9999),
            });
            this.prevItemContent.css({
                filter: "blur(".concat(percentOfScreen * 2, "px) brightness(").concat(1 - percentOfScreen * 0.25, ")"),
            });
        }
        else if (this.isFinalMove && this.willSwipeItem) {
            // percentOfScreen = 0
            this.currentItemContainer.css({
                zIndex: 0,
                transition: 'transform 400ms ease-in',
                transform: "scale(0.9) translateX(".concat(right2Left ? 25 : -25, "px)"),
            });
            this.currentItemContent.css({
                transition: "filter 400ms ease-in",
                filter: "blur(2px) brightness(0.75)",
            });
            this.nextItemContainer.css({
                transition: 'transform 400ms ease-in',
                transform: "scale(1) translateX(0px)",
                zIndex: 9999,
            });
            this.nextItemContent.css({
                transition: "filter 400ms ease-in",
                filter: "none",
            });
            this.prevItemContainer.css({
                transition: 'transform 400ms ease-in',
                transform: "scale(1) translateX(0px)",
                zIndex: 9999,
            });
            this.prevItemContent.css({
                transition: "filter 400ms ease-in",
                filter: "none",
            });
        }
        else if (this.isFinalMove && !this.willSwipeItem) {
            // percentOfScreen = 1
            this.currentItemContainer.css({
                zIndex: 9999,
                transition: 'transform 400ms ease-in',
                transform: "scale(1) translateX(0px)",
            });
            this.currentItemContent.css({
                transition: "filter 400ms ease-in",
                filter: "none",
            });
            this.nextItemContainer.css({
                transition: 'transform 400ms ease-in',
                transform: "scale(0.9) translateX(-25px)",
                zIndex: 0,
            });
            this.nextItemContent.css({
                transition: "filter 400ms ease-in",
                filter: "blur(2px) brightness(0.75)",
            });
            this.prevItemContainer.css({
                transition: 'transform 400ms ease-in',
                transform: "scale(0.9) translateX(25px)",
                zIndex: 0,
            });
            this.prevItemContent.css({
                transition: "filter 400ms ease-in",
                filter: "blur(2px) brightness(0.75)",
            });
        }
    };
    ZoomPinch.prototype.crossfadeAnimation = function (percentOfScreen, isDuringAnimation) {
        var scale = Math.round(100 * Math.max(0, (percentOfScreen - 0.5) * 2 - 0.96)) / 100 +
            0.96;
        var val = "translate3d(".concat(this.pos.x, "px ,").concat(this.pos.y, "px ,0)");
        this.wrap.css({
            transform: val,
            '-o-transform': val,
            '-ms-transform': val,
            '-webkit-transform': val,
        });
        if (isDuringAnimation) {
            var fastOpacity = Math.max(0, (percentOfScreen - 0.5) * 2);
            this.currentItemContainer.css({
                transition: 'none',
                transform: "scale(".concat(scale, ") translateX(").concat(-1 * this.pos.x, "px)"),
                opacity: fastOpacity,
            });
            this.nextItemContainer.css({
                transition: 'none',
                transform: "scale(".concat(scale, ") translateX(").concat(Number(this.pos.x), "px)"),
                opacity: 1 - fastOpacity,
            });
            this.prevItemContainer.css({
                transition: 'none',
                transform: "scale(".concat(scale, ")"),
                opacity: 1 - fastOpacity,
            });
        }
        else {
            this.currentItemContainer.css({
                transform: "none",
                opacity: 1,
            });
            this.nextItemContainer.css({
                transform: "none",
                opacity: 1,
            });
            this.prevItemContainer.css({
                transform: "none",
                opacity: 1,
            });
        }
    };
    // --------------------| UTILS |--------------------//
    ZoomPinch.prototype.isDoubleTap = function (tapTime, lastTapTime) {
        return tapTime - lastTapTime < 300;
    };
    ZoomPinch.prototype.isDraggingOutOfBounds = function (dirction) {
        dirction *= this.rtlFix;
        return ((this.isLastSlide && dirction < 0) || // if last slide and sliding right
            (this.isFirstSlide && dirction > 0)); // if first slide and sliding left;
    };
    ZoomPinch.prototype.isTap = function (startTouchEvent, endTouchEvent) {
        try {
            if (startTouchEvent.touches.length === 1 &&
                endTouchEvent.touches.length === 0 &&
                startTouchEvent.type !== 'touchmove' &&
                endTouchEvent.timeStamp - startTouchEvent.timeStamp < 150) {
                var startTouch = startTouchEvent.touches[0];
                var endTouch = endTouchEvent.changedTouches[0];
                var distanceX = Math.abs(startTouch.screenX - endTouch.screenX);
                var distanceY = Math.abs(startTouch.screenY - endTouch.screenY);
                return distanceX < 10 && distanceY < 10;
            }
            return false;
        }
        catch (e) {
            console.warn('StartTouch event is corrupt', startTouchEvent, endTouchEvent);
            return false;
        }
    };
    ZoomPinch.prototype.isSwipe = function (distance, duration) {
        var velocity = distance / duration;
        // determine if slide attempt triggers next/prev slide
        return ((distance > 10 && velocity > 0.5) || // quick swipe
            distance > this.container.width / 2); // large distance
    };
    ZoomPinch.prototype.calcBounds = function () {
        // moving scaled image - set boundaries
        var rect = this.currentItem[0].getBoundingClientRect();
        var cur_w = rect.width;
        var cur_h = rect.height;
        var max_x = Math.abs(cur_w - this.container.width) / 2;
        var max_y = Math.abs(cur_h - this.container.height) / 2;
        this.bounds = {
            max_x: max_x,
            max_y: max_y,
            min_x: -1 * max_x,
            min_y: -1 * max_y,
        };
        // console.log("calculated bounds", this.bounds);
    };
    ZoomPinch.prototype.calcTouchDirection = function (touches) {
        var delta;
        if (touches.length === 1) {
            delta = {
                x: Math.abs(touches[0].screenX - this.touchStart.x),
                y: Math.abs(touches[0].screenY - this.touchStart.y),
            };
        }
        else {
            delta = {
                x: Math.abs((touches[0].screenX + touches[1].screenX) / 2 - this.pinchStart.x),
                y: Math.abs((touches[0].screenY + touches[1].screenY) / 2 - this.pinchStart.y),
            };
        }
        var threshold = 10;
        if (delta.x >= threshold && delta.y < threshold) {
            return 'horizontal';
        }
        else if (delta.y >= threshold && delta.x < threshold) {
            return 'vertical';
        }
        else if (delta.y >= threshold && delta.x >= threshold) {
            return delta.x > delta.y ? 'horizontal' : 'vertical';
        }
        else {
            return '';
        }
    };
    // --------------------| HANDLERS |--------------------//
    ZoomPinch.prototype.onTouchStart = function (event) {
        // this.stopEvent(event, 'onTouchStart');
        this.willSwipeItem = false;
        this.isFinalMove = false;
        if (this.enabled) {
            this.touchStarted = true;
            this.move();
            this.beforeAnimation = false;
            this.startTouch = $.extend(true, {}, event); // the event object can change on some devices
            var touches = event.touches;
            this.turnTransitionOff();
            this.direction = 0;
            if (touches.length === 2) {
                this.handleStartPinching(event, touches);
            }
            else {
                var touch = event.touches[0];
                if (this.scale > 1) {
                    this.handleStartDragging(event, touch);
                }
                else {
                    this.handleStartSwiping(event, touch);
                }
            }
        }
        this.move();
        this.stopEvent(event, 'onTouchStart');
    };
    ZoomPinch.prototype.onTouchMove = function (event) {
        if (!this.enabled) {
            this.stopEvent(event, 'onTouchMove (disabled)');
            return;
        }
        if (!this.touchStarted) {
            this.onTouchStart(event);
        }
        var touches = event.touches;
        var touchDirection = this.touchDirection;
        if (!touchDirection) {
            touchDirection = this.calcTouchDirection(touches);
        }
        if (touchDirection === 'horizontal' ||
            !this.allowScroll ||
            touches.length > 1) {
            // swipping / pinching
            if (touches.length === 2) {
                if (!this.touchDirection) {
                    this.showHiResImages();
                    this.hideNonCurrentImages();
                }
                this.handlePinching(event, touches);
            }
            else if (touches.length === 1) {
                if (this.scale > 1) {
                    if (!this.touchDirection) {
                        this.showHiResImages();
                        this.hideNonCurrentImages();
                    }
                    this.handleDragging(event, touches);
                }
                else {
                    if (!this.touchDirection) {
                        this.hideHiResImages();
                        this.showNonCurrentImages();
                    }
                    var touch = touches[0];
                    this.handleSwipeDragging(event, touch);
                }
            }
            if (!this.touchDirection) {
                this.disableScroll();
                this.touchDirection = 'horizontal';
            }
            this.move();
        }
        else if (touchDirection === 'vertical') {
            // scrolling
            if (!this.touchDirection) {
                this.enableScroll();
                this.showHiResImages();
                this.touchDirection = touchDirection;
                // console.log('Got first touchDirection', this.touchDirection);
            }
            return true;
        }
        else {
            // undecided yet
            this.stopEvent(event, 'onTouchMove (undecided)');
            // console.log('waiting for touchDirection', this.touchDirection);
            return false;
        }
    };
    ZoomPinch.prototype.onTouchEnd = function (event) {
        var _this = this;
        if (this.scale === 1) {
            this.toggleZoom(false);
        }
        if (!this.enabled) {
            this.stopEvent(event, 'onTouchEnd (disabled)');
            return;
        }
        this.touchStarted = false;
        this.isFinalMove = true;
        this.turnTransitionOn();
        this.touchDirection = '';
        var endTouchTime = event.timeStamp;
        if (this.isTap(this.startTouch, event)) {
            if (this.isDoubleTap(endTouchTime, this.lastTapTime)) {
                clearTimeout(this.singleTapTimeout);
                this.handleDoubleTap(event);
            }
            else {
                // handle single tap - wait 300ms for double tap
                this.singleTapTimeout = setTimeout(function () {
                    _this.onTap(event);
                }, 300);
            }
            this.lastTapTime = endTouchTime;
        }
        if (this.scale > 1) {
            this.showHiResImages();
            this.hideNonCurrentImages();
            // bounce back to max scale of x2
            // if (this.scale > 2) {
            //   this.scale = 2; - removed because the just between scale > 2 to scale = 2 was annoying
            // }
        }
        else {
            this.disable(); // wait for the transition to end before allowing any touches
            // regular release - animate slides
            var currentX = this.pos.x;
            var distance = Math.abs(currentX);
            var duration = endTouchTime - this.startTouch.timeStamp;
            this.willSwipeItem =
                this.isSwipe(distance, duration) &&
                    !this.isDraggingOutOfBounds(currentX);
            if (this.willSwipeItem) {
                // determine direction of swipe
                this.direction = Math.sign(currentX);
                // set the new position of the slider
                this.pos.x = this.direction * this.container.width;
            }
            else {
                this.pos.x = 0;
                this.direction = 0;
            }
            this.pos.y = 0;
            this.move();
            if (currentX - this.pos.x === 0) {
                // if there is not transition going to happen, trigger transitionEnd event manually
                this.onTransitionEnd();
            }
            else {
                // otherwise - register to event end
                var element = this.wrap[0];
                if (element) {
                    element.addEventListener('webkitTransitionEnd', this.onTransitionEnd, this.opts);
                    element.addEventListener('msTransitionEnd', this.onTransitionEnd, this.opts);
                    element.addEventListener('oTransitionEnd', this.onTransitionEnd, this.opts);
                    element.addEventListener('otransitionend', this.onTransitionEnd, this.opts);
                    element.addEventListener('transitionend', this.onTransitionEnd, this.opts);
                }
            }
        }
    };
    ZoomPinch.prototype.onTransitionEnd = function () {
        var _this = this;
        this.pos = { x: 0, y: 0 };
        this.swipeCallback(-1 * this.rtlFix * this.direction, null, function () {
            _this.enable();
        });
        this.showHiResImages();
        this.showNonCurrentImages();
        this.move();
        var element = this.wrap[0];
        if (element) {
            element.removeEventListener('webkitTransitionEnd', this.onTransitionEnd, this.opts);
            element.removeEventListener('msTransitionEnd', this.onTransitionEnd, this.opts);
            element.removeEventListener('oTransitionEnd', this.onTransitionEnd, this.opts);
            element.removeEventListener('otransitionend', this.onTransitionEnd, this.opts);
            element.removeEventListener('transitionend', this.onTransitionEnd, this.opts);
        }
    };
    ZoomPinch.prototype.handleStartSwiping = function (event, touch) {
        // on movement start - the slider is at 0
        this.pos = {
            x: 0,
            y: 0,
        };
        // get initial touch coords
        this.touchStart = {
            x: touch.screenX,
            y: touch.screenY,
        };
    };
    ZoomPinch.prototype.handleStartDragging = function (event, touch) {
        this.showHiResImages();
        this.hideNonCurrentImages();
        this.calcBounds();
        this.pinchStart = {
            dist: 0,
            x: touch.screenX,
            y: touch.screenY,
        };
        // get initial touch coords
        this.touchStart = {
            x: touch.screenX - this.pos.x,
            y: touch.screenY - this.pos.y,
        };
    };
    ZoomPinch.prototype.handleStartPinching = function (event, touches) {
        // get the offset before transition to full screen to calc the toollbar
        // const offsetBefore = this.currentItem[0].getBoundingClientRect().top;
        this.isInExpandMode = false;
        if (!this.allowPinch) {
            this.isInExpandMode = true;
            this.onTap(event);
            event.preventDefault();
            event.stopPropagation();
        }
        this.showHiResImages();
        this.hideNonCurrentImages();
        this.calcBounds();
        var rect = this.currentItem[0].getBoundingClientRect();
        var touch1clientX = touches[0].clientX;
        var touch1clientY = touches[0].clientY;
        var touch2clientX = touches[1].clientX;
        var touch2clientY = touches[1].clientY;
        var touchesX = (touch1clientX + touch2clientX) / 2;
        var touchesY = (touch1clientY + touch2clientY) / 2;
        var imageOffsetX = rect.left;
        var imageOffsetY = rect.top;
        var imageWidth = rect.width;
        var imageHeight = rect.height;
        // relative touch position in the image
        var touchX = (((touchesX - imageOffsetX) / imageWidth - 0.5) * imageWidth) /
            this.scale;
        var touchY = (((touchesY - imageOffsetY) / imageHeight - 0.5) * imageHeight) /
            this.scale;
        this.pinchStart = {
            dist: Math.sqrt(Math.pow(touches[0].screenX - touches[1].screenX, 2) +
                Math.pow(touches[0].screenY - touches[1].screenY, 2)) / this.scale,
            x: (touches[0].screenX + touches[1].screenX) / 2 - (this.pos.x || 0),
            y: (touches[0].screenY + touches[1].screenY) / 2 - (this.pos.y || 0),
            touchX: touchX,
            touchY: touchY,
            touchScale: this.scale,
        };
        // calculate the offset of the image to make adjustments after the transition to expand mode
        // this.imageOffsetY = imageOffsetY - offsetBefore;
        // this.stopEvent(event, 'handleStartPinching');
    };
    ZoomPinch.prototype.handleSwipeDragging = function (event, touch) {
        this.stopEvent(event, 'handleSwipeDragging');
        if (!this.allowSwipe) {
            return;
        }
        // console.log('Got touch events', touches.screenX, touches.screenY);
        var delta = {
            x: touch.screenX - this.touchStart.x,
            y: touch.screenY - this.touchStart.y,
        };
        // console.log('Measured Delta', delta);
        // increase resistance if first or last slide
        if (this.isDraggingOutOfBounds(delta.x)) {
            delta.x /= Math.abs(delta.x) / this.container.width + 1; // determine resistance level
        }
        // set the new slides position
        this.pos = {
            x: delta.x,
            y: this.pos.y, // on regular swipe - do not change y position
        };
    };
    ZoomPinch.prototype.handleDragging = function (event, touches) {
        this.stopEvent(event, 'handleDragging');
        if (!this.allowPinch) {
            this.resetScale();
            return;
        }
        var deltaPinch = {
            x: touches[0].screenX - this.touchStart.x,
            y: touches[0].screenY - this.touchStart.y,
        };
        var x = deltaPinch.x;
        if (this.bounds.min_x > x && this.bounds.min_x - x < 100) {
            // do not limit the drag - but snap within 100px
            x = this.bounds.min_x;
        }
        if (this.bounds.max_x < x && x - this.bounds.max_x < 100) {
            x = this.bounds.max_x;
        }
        var y = deltaPinch.y;
        if (this.bounds.min_y > y && this.bounds.min_y - y < 100) {
            // (500 > 10
            y = this.bounds.min_y;
        }
        if (this.bounds.max_y < y && y - this.bounds.max_y < 100) {
            y = this.bounds.max_y;
        }
        this.pos = { x: x, y: y };
        // this.pos = {
        //   x: Math.min(Math.max(this.bounds.min_x, deltaPinch.x), this.bounds.max_x),
        //   y: Math.min(Math.max(this.bounds.min_y, deltaPinch.y), this.bounds.max_y)
        // };
    };
    ZoomPinch.prototype.handlePinching = function (event, touches) {
        // event.preventDefault();
        if (!this.allowPinch) {
            this.stopEvent(event, 'handlePinching (pinch not allowed)');
            return;
        }
        var deltaPinch = {
            scale: Math.sqrt(Math.pow(touches[0].screenX - touches[1].screenX, 2) +
                Math.pow(touches[0].screenY - touches[1].screenY, 2)) / this.pinchStart.dist,
            x: (touches[0].screenX + touches[1].screenX) / 2 - this.pinchStart.x,
            y: (touches[0].screenY + touches[1].screenY) / 2 - this.pinchStart.y,
        };
        if (this.isInExpandMode) {
            // fix zooming focus (zooming focus is a little bit off verticaly when transitioning from expand to fullscreen)
            // deltaPinch.y = deltaPinch.y - this.imageOffsetY * deltaPinch.scale;
        }
        var newScale = Math.max(1, deltaPinch.scale);
        var pinchPositionFix = {
            x: (newScale - this.pinchStart.touchScale) * this.pinchStart.touchX,
            y: (newScale - this.pinchStart.touchScale) * this.pinchStart.touchY,
        };
        this.pos = {
            x: deltaPinch.x - pinchPositionFix.x,
            y: deltaPinch.y - pinchPositionFix.y,
        };
        this.scale = newScale;
        this.stopEvent(event, 'handlePinching');
    };
    ZoomPinch.prototype.handleDoubleTap = function (event) {
        if (!this.allowPinch) {
            this.onTap(event);
            this.stopEvent(event, 'handleDoubleTap (pinch not allowed)');
            return;
        }
        if (this.scale > 1) {
            this.scale = 1;
            this.showNonCurrentImages();
        }
        else {
            this.scale = 2;
            this.hideNonCurrentImages();
        }
        this.pos = {
            x: 0,
            y: 0,
        };
        this.turnTransitionOn();
        this.showHiResImages();
        this.move();
    };
    ZoomPinch.prototype.resetScale = function () {
        this.scale = 1;
        this.pos = {
            x: 0,
            y: 0,
        };
        this.showNonCurrentImages();
        this.turnTransitionOn();
        this.showHiResImages();
        this.move();
    };
    ZoomPinch.prototype.stopEvent = function (event, src) {
        // console.log('Canceled default event', src);
        try {
            // event.stopPropagation();
            // event.preventDefault();
        }
        catch (e) {
            //
        }
    };
    return ZoomPinch;
}());
export default ZoomPinch;
//# sourceMappingURL=pincher.js.map